document.addEventListener("DOMContentLoaded", () => {
  const mobile = document.querySelector(".xo-product-info-media-mobile");
  if (!mobile) return;

  const list = mobile.querySelector("xo-carousel-list");
  const slides = [...list.querySelectorAll(":scope > xo-carousel-slide")];
  const dotsWrap = mobile.querySelector(".xo-product-info-media__dots");

  if (!dotsWrap || !slides.length) return;

  // Create dots
  slides.forEach((_, i) => {
    const dot = document.createElement("button");
    dot.className = "xo-product-info-media__dot";
    dot.type = "button";

    if (i === 0) dot.classList.add("active");

    dot.addEventListener("click", () => {
      slides[i].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });
    });

    dotsWrap.appendChild(dot);
  });

  const dots = [...dotsWrap.children];

  function updateDots() {
    let active = slides.findIndex(slide => slide.hasAttribute("xo-active"));
    if (active < 0) active = 0;

    dots.forEach((d, i) => d.classList.toggle("active", i === active));
  }

  updateDots();

  new MutationObserver(updateDots).observe(list, {
    subtree: true,
    attributes: true,
    attributeFilter: ["xo-active"]
  });
});